import dayjs from 'dayjs';

dayjs.locale('ko');

export function formatAMPMTime(time: string) {
  const date = dayjs(time);
  const hour = date.hour();
  const minute = date.minute();

  const isAM = new Date(time).getHours() < 12;

  return `${isAM ? '오전' : '오후'} ${hour}시 ${minute
    .toString()
    .padStart(2, '0')}분`;
}

export function isBetweenDate(begin: string, end: string) {
  const now = dayjs();
  const startDate = dayjs(begin);
  const endDate = dayjs(end);

  return now.isAfter(startDate) && now.isBefore(endDate);
}

export function isAfterDate(pivot: string) {
  const now = dayjs();
  const pivotDate = dayjs(pivot);

  return now.isAfter(pivotDate);
}

export function getKoDate(date: `${number}-${number}-${number}`) {
  const day = dayjs(date).day();

  switch (day) {
    case 0:
      return '일';
    case 1:
      return '월';
    case 2:
      return '화';
    case 3:
      return '수';
    case 4:
      return '목';
    case 5:
      return '금';
    case 6:
      return '토';
    default:
      return '';
  }
}
